module.exports = __webpack_public_path__ + "img/logo.8963a659.png";